import { Select as SelectPrimitive } from "@base-ui/react/select"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const SelectSeparator = ({ className, ...props }) => (
  <SelectPrimitive.Separator
    data-slot="select-separator"
    className={classNames("-mx-1 my-1 h-px bg-gray-200", className)}
    {...props}
  />
)

SelectSeparator.propTypes = {
  className: PropTypes.string,
}

export default SelectSeparator
